import type { LocationFilterDTO } from '@cognite/apm-config';

import type { InFieldCDMLocationConfig } from '../../../features/app-config/cdm-types';
import { hashCodeForInstanceId } from '../../../utils/hashcode';

/**
 * Converts an array of InFieldCDMLocationConfig to LocationFilterDTO array
 * This is used as list of locations for idm projects that is expected by
 * AppConfigProvider and its AppConfigContext.
 * @param allLocationConfigs - The array of InFieldCDMLocationConfig to convert
 * @returns The array of LocationFilterDTO
 */
export const convertInfieldLocationConfigsToIdmLocations = (
  allLocationConfigs: InFieldCDMLocationConfig[]
): LocationFilterDTO[] => {
  if (!allLocationConfigs) {
    return [];
  }

  return allLocationConfigs
    .filter((location) => location.space && location.externalId)
    .map((location) => ({
      externalId: location.externalId,
      id: hashCodeForInstanceId(location.externalId, location.space),
      name: location.name ?? location.externalId,
      createdTime: location.createdTime ?? 0,
      lastUpdatedTime: location.lastUpdatedTime ?? 0,
      space: location.space,
    }));
};
